<div class="loading-overlay">
    <div class="spinner"></div>
</div>